import React from 'react';
import Slider from "react-slick";
import Client_1 from '../../../assets/images/client-1.webp';
import Client_2 from '../../../assets/images/client-2.webp';
import Client_3 from '../../../assets/images/client-3.webp';
import Client_4 from '../../../assets/images/client-4.webp';


const Portfolio = () => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive:[
            {
                breakpoint:992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint:768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return(
        <>
        <section className="our-client-sec">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="our-client-inner-wrp">
                            <h2 className="common-title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="1000">Our Portfolio</h2>
                        </div>
                        <div className="our-client-slider-wrp">
                        <Slider {...settings}>
      <div className="client-slider-item"  data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
        <figure role="none" className="client-img">
            <img src={Client_1} alt="Client 1" />
        </figure>
      </div>
      <div className="client-slider-item"  data-aos="flip-right" data-aos-duration="1000" data-aos-delay="1000">
      <figure role="none" className="client-img">
            <img src={Client_2} alt="Client 1" />
        </figure>
      </div>
      <div className="client-slider-item"  data-aos="flip-right" data-aos-duration="1000" data-aos-delay="1500">
      <figure role="none" className="client-img">
            <img src={Client_3} alt="Client 1" />
        </figure>
      </div>
      <div className="client-slider-item"  data-aos="flip-right" data-aos-duration="1000" data-aos-delay="2000">
      <figure role="none" className="client-img">
            <img src={Client_4} alt="Client 1" />
        </figure>
      </div>
       
    </Slider>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
        </>
    )
}

export default Portfolio;